<template>
  <v-form v-bind="this.$attrs">
    <v-row class="flex-center-between">
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Kỳ đóng</div>
        <div class="text-name nowrap">{{ detailPeriod.title | convertFullDate }}</div>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Trạng thái</div>
        <v-chip small class="white--text" :color="statusColor()" label>
          <span class="white--text">{{ status() }}</span>
        </v-chip>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Tổng kết lần cuối</div>
        <div class="text-name nowrap" v-if="detailPeriod.status !== 'created'">
          {{ detailPeriod.updatedAt | ddmmyyyyhhmm }}
        </div>
        
        <div class="text mb-2 mt-4">Cập nhật đóng kỳ</div>
        <div class="text-name nowrap" v-if="detailPeriod.frozenBy">
          {{ $get(detailPeriod, 'frozenBy.name') }}
          <span style="font-size: 14px; color: #797979; font-weight: normal; margin-left: 4px;">({{ detailPeriod.frozenAt | ddmmyyyyhhmm }})</span>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <div class="text mb-2">Người thực hiện</div>
        <div class="text-name nowrap" v-if="detailPeriod.status !== 'created'">
          {{ $get(detailPeriod, 'generatedBy.name', '') }}
        </div>
        
        <div class="text mb-2 mt-4">Cập nhật mở kỳ</div>
        <div class="text-name nowrap" v-if="detailPeriod.unfrozenBy">
          {{ $get(detailPeriod, 'unfrozenBy.name') }}
          <span style="font-size: 14px; color: #797979; font-weight: normal; margin-left: 4px;">({{ detailPeriod.unfrozenAt | ddmmyyyyhhmm }})</span>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { periodHelper } from '@/modules/tuitionFee/detail-period/helper/textHelper'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapMutations('tuitionFeeReport', ['resetData']),
    ...mapMutations('tuitionFeePeriod', ['resetDataPeriod']),
    statusColor() {
      return periodHelper.statusColorPeriod(this.detailPeriod.status)
    },
    status() {
      return periodHelper.statusPeriod(this.detailPeriod.status)
    },
  },
  async created() {
    await this.resetData()
    await this.resetDataPeriod()
  }
}
</script>

<style scoped>
.text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #797979;
}

.text-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: max-content;
  max-width: 100%;
}
.tooltip {
  word-wrap: break-word;
}
</style>
